import type { AxiosRequestConfig, AxiosResponse } from 'axios';

class EOneRequestError extends Error {
  silent: boolean | undefined;
  status: number | undefined;
  config: AxiosRequestConfig<any> | undefined;
  request: XMLHttpRequest | undefined;
  response: AxiosResponse<any, any> | undefined;
  error: any | undefined;
  /** Backend error code (e.g. from BaseResponse.ErrorCode). Used to decide toast vs modal. */
  errorCode: string | undefined;

  constructor(
    message: string,
    {
      status,
      config,
      request,
      response,
      error,
      errorCode,
    }: {
      status?: number;
      config?: AxiosRequestConfig;
      request?: XMLHttpRequest;
      response?: AxiosResponse;
      error?: any;
      /** Backend error code when success=false or 4xx/5xx body has errorCode */
      errorCode?: string;
    },
  ) {
    super(message);
    this.name = 'EOneRequestError';

    this.status = status;
    this.config = config;
    this.request = request;
    this.response = response;
    this.error = error;
    this.errorCode = errorCode;
  }
}

export { EOneRequestError };
